import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';

import { REACTIVE_FORM_BUILDER_ENVIRONMENT } from '../../adapters/reactive-form-builder.adapters';

export type ReactiveFormSupportDataReadinessPhase = 'critical' | 'deferred' | 'lazy';

export type ReactiveFormSupportDataReadinessStatus = 'pending' | 'loading' | 'ready' | 'lazy' | 'error';

export type ReactiveFormSupportDataReadinessSeverity = 'info' | 'success' | 'warning' | 'danger';

export interface ReactiveFormSupportDataReadinessItem {
  readonly id: string;
  readonly label: string;
  readonly phase: ReactiveFormSupportDataReadinessPhase;
  readonly status: ReactiveFormSupportDataReadinessStatus;
  readonly detail?: string;
}

const SUPPORT_DATA_STATUS_LABELS: Record<ReactiveFormSupportDataReadinessStatus, string> = {
  pending: 'Pendiente',
  loading: 'Cargando',
  ready: 'Listo',
  lazy: 'Bajo demanda',
  error: 'Error',
};

const SUPPORT_DATA_PHASE_LABELS: Record<ReactiveFormSupportDataReadinessPhase, string> = {
  critical: 'Inicial',
  deferred: 'Diferido',
  lazy: 'Bajo demanda',
};

@Component({
  selector: 'app-reactive-form-support-data-readiness',
  standalone: false,
  templateUrl: './support-data-readiness.component.html',
  styleUrls: ['./support-data-readiness.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReactiveFormSupportDataReadinessComponent {
  @Input() public visible = true;

  @Input() public title = 'Datos complementarios del formulario';

  @Input() public summary = '';

  @Input() public severity: ReactiveFormSupportDataReadinessSeverity = 'info';

  @Input() public items: readonly ReactiveFormSupportDataReadinessItem[] = [];

  private readonly environment = inject(REACTIVE_FORM_BUILDER_ENVIRONMENT);

  public get shouldRender(): boolean {
    return this.visible && !this.environment.production && this.items.length > 0;
  }

  public get severityClass(): string {
    return 'reactive-form-support-data-readiness--' + this.severity;
  }

  public get icon(): string {
    switch (this.severity) {
    case 'danger':
      return 'pi-exclamation-triangle';
    case 'warning':
      return 'pi-clock';
    case 'success':
      return 'pi-check-circle';
    case 'info':
      return 'pi-spin pi-spinner';
    }
  }

  public getStatusLabel(status: ReactiveFormSupportDataReadinessStatus): string {
    return SUPPORT_DATA_STATUS_LABELS[status];
  }

  public getPhaseLabel(phase: ReactiveFormSupportDataReadinessPhase): string {
    return SUPPORT_DATA_PHASE_LABELS[phase];
  }

  public trackByItem(index: number, item: ReactiveFormSupportDataReadinessItem): string {
    return `${index}:${item.id}`;
  }
}
